import React from 'react';
import { Col, Form, Select } from 'antd';
import { commonProps } from '../../../../../common/types/commonTypes';
import { ITourTicketInfo } from '../../../RefundTypes/RefundTypes';

type PropsType = {
  ticketData?: ITourTicketInfo[];
} & commonProps;

export const SelectTicketRefund = ({
  name,
  label,
  size,
  required,
  disabled,
  ticketData,
}: PropsType) => {
  const tourInvoiceDataChildren: React.ReactNode[] = [];
  if (ticketData) {
    for (let i = 0; i < ticketData.length; i++) {
      tourInvoiceDataChildren.push(
        <Select.Option
          key={ticketData[i].itinerary_id}
          value={ticketData[i].itinerary_id}
        >
          {`${ticketData[i].itinerary_particular}`}
        </Select.Option>
      );
    }
  }
  return (
    <Col span={6} xs={24} sm={24} md={24} lg={size ? size : 8}>
      <Form.Item
        name={name}
        label={label}
        rules={[
          {
            required: required,
            message: 'Select Ticker Itenery is required',
          },
        ]}
      >
        <Select
          allowClear
          disabled={disabled}
          placeholder={label}
          showSearch
          style={{ padding: '0', margin: '0', border: '0' }}
          optionFilterProp='roleMobile'
          filterOption={(input, option) =>
            (option!.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          mode='multiple'
        >
          {tourInvoiceDataChildren}
        </Select>
      </Form.Item>
    </Col>
  );
};
